//hook
import { UserConsumer } from "../../hooks/context/UserContext";
//image
import howItWorks from "../../../src/assets/home/how-it-work.png"

//translate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";

//mui icon
import AddCallIcon from '@mui/icons-material/AddCall';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';


const Contact = () => {
  const { t } = useTranslation();
  const {theme} = UserConsumer()
  return (
      <div className='mt-20'>
        <div className='mb-20 text-center'>
          <h2 className='text-darkColor font-[800] text-3xl max-sm:text-xl mb-2'>{t("contact")}</h2>
          <div className='mt-5 mb-5'>
            <img 
            className='m-auto' 
            src={howItWorks} 
            alt='no-photo'
            loading="lazy"
            decoding="async"
            />
          </div>
          <h3 className="text-center mx-auto mb-5 font-bold text-[38px] leading-[42px]">{t("contact_info1")}</h3>
          <p>{t("contact_info2")}</p>
        </div>
        <div>

        </div>
        <div className='grid grid-cols-3 grid-rows-1 gap-3 mt-5'>
          <div className="flex flex-col gap-3 sm:p-6 p-1 rounded-xl bg-white shadow-2xl hover:shadow-xl transition-shadow duration-300">
            <div className={`w-fit p-2 rounded-md ${theme === "client" ? "bg-[#34a83554]" : "bg-[#fe83003d]"}`}>
              <AddCallIcon className={`${theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}`}/>
            </div>
            <h3 className='font-[800] max-sm:text-[13px]'>{t("call_us")}</h3>
            <p className='flex-1 max-sm:text-[10px]'>{t("call_us_info")}</p>
            <a className={`text-lg ${theme === "client" ? "text-customerColor hover:text-[#34a835a3]" : "text-paretnerColor"}`} href="tel:963987456321" target="_blank">
            {i18n.language === "ar" ? "963987456321+" : "+963987456321"}
            </a>
            <div className="flex items-center gap-3 text-sm">
              <AccessAlarmsIcon className="!text-lg"/>
              <p>24/7 {t("support")}</p>
            </div>
          </div>
          <div className="flex flex-col gap-3 sm:p-6 p-1 rounded-xl bg-white shadow-2xl hover:shadow-xl transition-shadow duration-300">           
            <div className={`w-fit p-2 rounded-md ${theme === "client" ? "bg-[#34a83554]" : "bg-[#fe83003d]"}`}>
              <WhatsAppIcon className={`${theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}`}/>
            </div>
            <h3 className='font-[800] max-sm:text-[13px]'>{t("whatsapp")}</h3>
            <p className='flex-1 max-sm:text-[10px]'>{t("whatsapp_info")}</p>
            <a className={`text-lg ${theme === "client" ? "text-customerColor hover:text-[#34a835a3]" : "text-paretnerColor"}`} href="https://wa.me/963987456321" target="_blank">
              {t("message_now")}
            </a>
            <div className="flex items-center gap-3 text-sm">
              <AccessAlarmsIcon className="!text-lg"/>
              <p>24/7 {t("available")}</p>
            </div>
          </div>
          <div className="flex flex-col gap-3 sm:p-6 p-1 rounded-xl bg-white shadow-2xl hover:shadow-xl transition-shadow duration-300">           
            <div className={`w-fit p-2 rounded-md ${theme === "client" ? "bg-[#34a83554]" : "bg-[#fe83003d]"}`}>
              <EmailIcon className={`${theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}`}/>
            </div>
            <h3 className='font-[800] max-sm:text-[13px]'>{t("email")}</h3>
            <p className='flex-1 max-sm:text-[10px]'>{t("mail_info")}</p>
            <a className={`text-lg ${theme === "client" ? "text-customerColor hover:text-[#34a835a3]" : "text-paretnerColor"}`} href="mailto:contact@getaak.com">
              {t("contact@getaak.com")}
            </a>
            <div className="flex items-center gap-3 text-sm">
              <AccessAlarmsIcon className="!text-lg"/>
              <p>{t("reply_within")}</p>
            </div>
          </div>
        </div>

      </div>
  )
}

export default Contact